let defaultAgent = {
    fio: '',
    agency_id: null,
    phoneNumbers: [
        {phoneNumber: ''},
    ],
};

export default defaultAgent;
